import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaymentDatePage } from './payment-date.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentDatePage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentDatePageRoutingModule {}
